import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Input, InputLabel, Grid, Button } from '@material-ui/core';
import { DatePicker } from 'material-ui-pickers';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import CriteriaImage from 'CriteriaImage';

const Container = styled.div`
  padding: 1rem 1rem;
  @media (min-width: 1124px) {
    padding: 1.5rem 6rem;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1024px;
`;

const Inputs = styled.div`
  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const CustomInputLabel = styled(InputLabel)`
  &&& {
    padding-right: 8px;

    width: 36%;
    font-size: 0.75rem;
    font-weight: 300;
  }
`;
const CustomDateInputLabel = styled(InputLabel)`
  &&& {
    margin-right: 1rem;
    display: block;
    width: 4.375rem;
    font-size: 0.75rem;
    font-weight: 300;
  }
`;

const InnerDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
`;

const Dates = styled.div`
  //flex: 1;
  display: flex;
  align-items: center;
`;
const Required = styled.span`
  color: red;
`;
const SubmitWraper = styled(Grid)`
  align-self: right;
  button {
    float: right;
  }
`;

var tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

function Reference(props) {
  const {
    endDate,
    startDate,
    onChangeDate,
    mountingType,
    mountingPosition,
    onSuggest,
    setLocationOnPlan,
    setTicketReference,
    setDescription,
  } = props;
  const [ticketReference, setTickRef] = useState('');
  const [locationOnPlan, setLocOnPlan] = useState('');
  const [description, setDesc] = useState('');

  const [underlineTicketReference, setUnderlineTicketReference] = useState(
    !props.isEdit ? 'underline--c-red' : ''
  );
  const [underlineLocationOnPlan, setUnderlineLocationOnPlan] = useState(
    !props.isEdit ? 'underline--c-red' : ''
  );

  useEffect(() => {
    if (props.isEdit) {
      setTickRef(props.ticketReference);
      setLocOnPlan(props.locationOnPlan);
      setDesc(props.description);
    } else {
      if (props.ticketReference !== '') {
        setUnderlineTicketReference('');
      }
      if (props.locationOnPlan !== '') {
        setLocOnPlan('');
      }
      if (props.description !== '') {
        setDesc('');
      }
    }
  }, [
    props.ticketReference,
    props.locationOnPlan,
    props.isEdit,
    props.description,
  ]);

  const doChange = (name, event, e) => {
    if (name === 'ticketReference') {
      if (event.length <= 12) {
        setTicketReference(event, 'ticketReference');
      }
    } else if (name === 'locationOnPlan') {
      if (event.length <= 64) {
        setLocationOnPlan(event, 'locationOnPlan');
      }
    } else if (name === 'description') {
      if (event.length <= 64) {
        setDescription(event, 'description');
      }
    }
  };

  const handleChange = (name, event, e) => {
    if (name === 'ticketReference') {
      if (event !== '') {
        setUnderlineTicketReference('');
      } else {
        setUnderlineTicketReference('');
      }
      if (event.length <= 12) {
        setTickRef(event);
      } else {
        alert('You can write up to 12 characters');
      }
    } else if (name === 'locationOnPlan') {
      if (event.length <= 64) {
        setLocOnPlan(event);
      } else {
        alert('max size name is 64 characters');
      }
    } else if (name === 'description') {
      if (event.length <= 128) {
        setDesc(event);
      } else {
        alert('max size name is 128 characters');
      }
    }
  };

  return (
    <Container>
      <Grid container spacing={24}>
        <Grid item xs={12} md={1}>
          <CriteriaImage
            mountingType={mountingType}
            mountingPosition={mountingPosition}
          />
        </Grid>
        <Grid item xs={12} md={11}>
          <Grid container spacing={24}>
            <Grid item xs={12} md={4}>
              <Inputs>
                <InputWrapper>
                  <CustomInputLabel htmlFor="ticketReference">
                    Search reference<Required>*</Required>
                  </CustomInputLabel>
                  <Input
                    value={ticketReference}
                    fullWidth
                    id="ticketReference"
                    onChange={event =>
                      handleChange('ticketReference', event.target.value, event)
                    }
                    onBlur={event =>
                      doChange('ticketReference', event.target.value, event)
                    }
                    classes={{
                      underline: underlineTicketReference,
                    }}
                    placeholder={'Up to 12 characters'}
                  />
                </InputWrapper>
                <InputWrapper>
                  <CustomInputLabel htmlFor="location">
                    Location on plan
                  </CustomInputLabel>
                  <Input
                    value={locationOnPlan}
                    fullWidth
                    id="location"
                    onChange={event =>
                      handleChange('locationOnPlan', event.target.value, event)
                    }
                    onBlur={event =>
                      doChange('locationOnPlan', event.target.value, event)
                    }
                    placeholder={'Up to 64 characters'}
                  />
                </InputWrapper>
                <InputWrapper>
                  <CustomInputLabel htmlFor="description">
                    Description
                  </CustomInputLabel>
                  <Input
                    value={description}
                    fullWidth
                    id="description"
                    onChange={event =>
                      handleChange('description', event.target.value, event)
                    }
                    onBlur={event =>
                      doChange('description', event.target.value, event)
                    }
                    placeholder={'Up to 128 characters'}
                  />
                </InputWrapper>
              </Inputs>
            </Grid>
            <Grid item xs={12} md={4}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <InnerDateWrapper>
                  <Dates>
                    <CustomDateInputLabel>Search starts</CustomDateInputLabel>
                    <DatePicker
                      fullWidth
                      disabled
                      value={startDate}
                      onChange={onChangeDate('startDate')}
                      format="YYYY MMM DD"
                    />
                  </Dates>
                  <Dates>
                    <CustomDateInputLabel>Search expires</CustomDateInputLabel>
                    <DatePicker
                      fullWidth
                      value={endDate}
                      minDate={tomorrow}
                      onChange={onChangeDate('endDate')}
                      format="YYYY MMM DD"
                      minDateMessage={'End date must be after start date'}
                    />
                  </Dates>
                </InnerDateWrapper>
              </MuiPickersUtilsProvider>
            </Grid>
            <SubmitWraper item xs={12} md={4}>
              <Button
                // disabled={props.isEdit}
                classes={{
                  root: 't-primary-16 c-s-blue',
                }}
                variant="contained"
                color="primary"
                onClick={onSuggest()}
              >
                Suggest
              </Button>
            </SubmitWraper>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
export default Reference;
